import { useSelector } from "react-redux";

import { getParentEmailThreadsFolder } from "@app/component/EntityEmails/store/selectors";
import getEmailFolderAnalyticsName from "@app/component/EntityEmails/util/getEmailFolderAnalyticsName";
import { useExtendedAnalytics } from "@app/util/analytic/AnalyticsService";
import useAnalytics from "@app/util/contexts/useAnalytics";

const useParentEmailThreadsFolderAnalytics = () => {
  const analytics = useAnalytics();
  const parentEmailsFolder = useSelector(getParentEmailThreadsFolder);

  return useExtendedAnalytics(getEmailFolderAnalyticsName(parentEmailsFolder), analytics);
};

export default useParentEmailThreadsFolderAnalytics;
